import { createAsyncThunk } from '@reduxjs/toolkit';
import ChatBot from '../ChatBot';
import Server from '../../../Server';
import { toast } from 'react-toastify';
import { CHAT_BOT_API, CHAT_BOT_HISTORY, CHAT_BOT_HISTORY_MESSAGES, POST_MESSAGES } from '../../../API/Endpoint';


export const createChat = createAsyncThunk(
    "chatbot/createChat",
    async ({ body }, thunkAPI) => {
        try {
            const res = await Server.post(CHAT_BOT_API, body, true);
            if (res?.success) {
                return res.payload; // 
            } else {
                toast.error("Failed to create chat", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    style: { fontSize: "16px" },
                });
                return thunkAPI.rejectWithValue("Failed to create chat");
            }
        } catch (err) {
            console.error("API Error:", err);
            console.log("Error Response:", err.response);

            return thunkAPI.rejectWithValue(
                err?.response?.data?.message || "Something went wrong"
            );
        }
    }
);

export const getHistoryListing = createAsyncThunk(
    "chatbot/getHistoryListing",
    async (_, thunkAPI) => {
        try {
            const res = await Server.get(CHAT_BOT_HISTORY, true);
            if (res?.success) {
                console.log(res,"response");
                return res.payload; // 
            } else {
                toast.error("Failed to create chat", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    style: { fontSize: "16px" },
                });
                return thunkAPI.rejectWithValue("Failed to create chat");
            }
        } catch (err) {
            console.log("Error Response:", err.response);
            return thunkAPI.rejectWithValue(
                err?.response?.data?.message || "Something went wrong"
            );
        }
    }
);

export const getHistoryMessages = createAsyncThunk(
    "chatbot/getHistoryMessages",
    async (sessionId, thunkAPI) => {
        try {
            const res = await Server.get(`${CHAT_BOT_HISTORY_MESSAGES}${sessionId}`, true);
            if (res?.success) {
                return res.payload; // 
            } else {
                toast.error("Failed to create chat", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    style: { fontSize: "16px" },
                });
                return thunkAPI.rejectWithValue("Failed to create chat");
            }
        } catch (err) {
            console.log("Error Response:", err.response);
            return thunkAPI.rejectWithValue(
                err?.response?.data?.message || "Something went wrong"
            );
        }
    }
);

export const addHistoryMessages = createAsyncThunk(
    "chatbot/addHistoryMessages",
    async ({body}, thunkAPI) => {
        try {
            const res = await Server.post(`${POST_MESSAGES}`,body, true);
            if (res?.success) {
                return res.payload; // 
            } else {
                toast.error("Failed to create chat", {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    style: { fontSize: "16px" },
                });
                return thunkAPI.rejectWithValue("Failed to create chat");
            }
        } catch (err) {
            console.log("Error Response:", err.response);
            return thunkAPI.rejectWithValue(
                err?.response?.data?.message || "Something went wrong"
            );
        }
    }
);








